import * as React from "react";
import { SVGProps } from "react";
const SvgFullscreenExit = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M25.1 11.8c.5.1.9.5.9 1 0 .6-.4 1-1 1h-.1c-1-.1-2-.3-3-.5-1.6-.3-2.8-1.6-3.2-3.2-.2-1-.4-2-.5-3-.1-.5.3-1 .9-1.1h.1c.5 0 .9.4 1 .9.1 1 .3 1.9.5 2.9.2.8.8 1.4 1.5 1.5 1 .3 2 .4 2.9.5ZM11.8 6.9c-.1 1-.3 1.9-.5 2.9-.2.8-.8 1.4-1.5 1.5-1 .2-1.9.3-2.9.5-.5.1-.9.5-.9 1 0 .6.4 1 1 1h.1c1-.1 2-.3 3-.5 1.6-.3 2.9-1.6 3.2-3.2.16-.8.32-1.6.429-2.4l.071-.6c.1-.5-.3-1-.9-1.1h-.1c-.5 0-1 .4-1 .9ZM6.9 20.2c1 .1 1.9.3 2.9.5.747.187 1.32.722 1.473 1.361l.027.139c.2 1 .3 1.9.5 2.9.1.5.5.9 1 .9.6 0 1-.4 1-1v-.1c-.1-1-.3-2-.5-3-.3-1.6-1.6-2.8-3.2-3.2-1-.2-2-.4-3-.5-.5-.1-1 .3-1.1.9v.1c0 .6.4 1 .9 1Zm13.3 4.9c.1-1 .3-1.9.5-2.9.187-.747.722-1.32 1.361-1.473l.139-.027c1-.2 1.9-.3 2.9-.5.5-.1.9-.5.9-1 0-.6-.4-1-1-1h-.1c-1 .1-2 .3-3 .5-1.6.3-2.9 1.6-3.2 3.2-.2 1-.4 2-.5 3-.1.5.3 1 .9 1.1h.1c.5 0 1-.4 1-.9Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgFullscreenExit;
